import React from 'react';
import { colors } from './constants';

const TopDomains = ({ topDomains, totalExperiences }) => (
  <div>
    <h2 className="text-lg font-semibold text-gray-800 mb-3 flex items-center">
      <span className="w-1.5 h-5 bg-orange-500 rounded-sm mr-2"></span>
      Top domaines d'expérience
    </h2>
    <div className="bg-white rounded-xl shadow-md border border-gray-100 overflow-hidden">
      <div className="h-2" style={{ background: colors.gradient.orange }}></div>
      <div className="p-5">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {topDomains.map((domain, index) => (
            <div key={index} className="bg-gray-50 p-4 rounded-lg border border-gray-100">
              <div className="flex justify-between mb-2">
                <span className="text-gray-800 font-medium flex items-center">
                  <span className="w-6 h-6 rounded-full flex items-center justify-center mr-2 text-xs text-white" style={{ background: colors.gradient.orange }}>
                    {index + 1}
                  </span>
                  {domain.name}
                </span>
                <span className="text-orange-500 font-bold">{domain.value}</span>
              </div>
              <div className="w-full bg-gray-200 rounded-full h-2">
                <div 
                  className="h-2 rounded-full" 
                  style={{ 
                    width: `${totalExperiences > 0 ? (domain.value / totalExperiences) * 100 : 0}%`,
                    background: colors.gradient.orange
                  }}
                ></div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  </div>
);

export default TopDomains;
